<!--
/**
* @desc 功能描述
* @author wangyuanqin
* @date 2020年05月15日17:56,星期五
*/
-->
<template>
    <div v-if="count.length <= 0">
        <div class="noContent"
             v-if="!count.length>0&&count!==''">
            <img src="static/images/noContent.png">
            <p>{{content?content:'暂无数据'}}</p>
        </div>
        <div :class="[addClass]"
             v-if="count===''&&Shape&&!styleIndex">
            <div :class="[addClass+'-three1']"></div>
            <div :class="[addClass+'-three2']"></div>
            <div :class="[addClass+'-three3']"></div>
        </div>
        <div :class="[addClass]"
             v-if="count===''&&Shape&&styleIndex===1">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span>
        </div>
        <div :class="[addClass]"
             v-if="count===''&&Shape&&styleIndex===2">
            <div class="bounce bounce1"></div>
            <div class="bounce bounce2"></div>
        </div>
        <div :class="[addClass]"
             v-if="count===''&&Shape&&styleIndex===3">
            <div class="circle circle1">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="circle circle2">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
            <div class="circle circle3">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
        <div :class="[addClass]"
             v-if="count===''&&Shape&&styleIndex===4">
            <div class="loader-line-wrap">
                <div class="loader-line"></div>
            </div>
            <div class="loader-line-wrap">
                <div class="loader-line"></div>
            </div>
            <div class="loader-line-wrap">
                <div class="loader-line"></div>
            </div>
            <div class="loader-line-wrap">
                <div class="loader-line"></div>
            </div>
            <div class="loader-line-wrap">
                <div class="loader-line"></div>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    props: ['count', 'content', 'styleIndex'],
    data () {
        return {
            Shape: false
        }
    },
    watch: {
        count: {
            handler (val) {
                this.Shape = false
                if (val === '') {
                    setTimeout(() => {
                        if (!this.count.length > 0) this.Shape = true
                    }, 1000)
                }
            },
            immediate: true
        }
    },
    computed: {
        addClass () {
            let val = this.styleIndex || 0
            switch (val) {
                case 0: return 'loading-shape' + val
                default: return 'loading-shape' + val
            }
        }
    }
}
</script>
<style scoped lang='stylus' rel='stylesheet/stylus'>
@import '~common/stylus/variable.styl'
.noContent {
    width: 100%
    background-color: #ffffff
    padding: 0.5rem 0
    text-align: center
    color: #909BA8
    font-size: 0.14rem
    >img {
        width: 20%
        display: inline-block
        margin: 0 auto
        margin: 0.16rem
    }
}
/* loading0 */
.loading-shape0 {
    width: 150px
    margin: 50px auto
    text-align: center
    &-three1 {
        animation-delay: -0.3s !important
    }
    &-three2 {
        animation-delay: -0.15s !important
    }
    >div {
        width: 18px
        height: 18px
        border-radius: 100%
        display: inline-block
        background-color: $color-send-quote
        animation: three 1.4s infinite ease-in-out
        -webkit-animation-fill-mode: both
        animation-fill-mode: both
        @keyframes three {
            0%, 80%, 100% {
                -webkit-transform: scale(0)
            }
            40% {
                -webkit-transform: scale(1)
            }
        }
    }
}
/* loading1 */
.loading-shape1 {
    width: 50px
    height: 40px
    margin: 60px auto
    text-align: center
    span {
        width: 5px
        height: 100%
        display: inline-block
        background: $color-send-quote
        animation: mymove 1.2s infinite ease-in-out
        /*
            mymove代表动画名字
            1.2s代表执行时间
            infinite表示一直循环执行
            ease-in-out表示先慢后快的缓动
        */
        &:nth-child(2) {
            animation-delay: -1s
        }
        &:nth-child(3) {
            animation-delay: -0.9s
        }
        &:nth-child(4) {
            animation-delay: -0.8s
        }
        &:nth-child(5) {
            animation-delay: -0.7s
        }
        @keyframes mymove {
            0% {
                transform: scaleY(0.4)
            }
            25% {
                transform: scaleY(1)
            }
            50% {
                transform: scaleY(0.4)
            }
            75% {
                transform: scaleY(0.4)
            }
            100% {
                transform: scaleY(0.4)
            }
        }
        @keyframes mymove {
            0% {
                transform: scaleY(0.4)
            }
            25% {
                transform: scaleY(1)
            }
            50% {
                transform: scaleY(0.4)
            }
            75% {
                transform: scaleY(0.4)
            }
            100% {
                transform: scaleY(0.4)
            }
        }
    }
}
/* loading2 */
.loading-shape2 {
    width: 50px
    height: 50px
    margin: 50px auto
    position: relative
    .bounce {
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
        border-radius: 50%
        background-color: $color-send-quote
        opacity: 0.6
        animation: bounce 2s infinite ease-in-out
    }
    .bounce2 {
        animation-delay: -1s
    }
    @keyframes bounce {
        0% {
            transform: scale(0)
        }
        50% {
            transform: scale(1)
        }
        100% {
            transform: scale(0)
        }
    }
    @keyframes bounce {
        0% {
            transform: scale(0)
        }
        50% {
            transform: scale(1)
        }
        100% {
            transform: scale(0)
        }
    }
}
/* loading3 */
.loading-shape3 {
    width: 30px
    height: 30px
    margin: 50px auto
    position: relative
    .circle {
        position: absolute
        top: 0
        left: 0
        width: 100%
        height: 100%
    }
    .circle span {
        width: 8px
        height: 8px
        display: inline-block
        background: $color-send-quote
        border-radius: 100%
        position: absolute
        animation: mycircle 1.2s infinite ease-in-out
        animation-fill-mode: both
    }
    .circle2 {
        transform: rotateZ(45deg)
    }
    .circle3 {
        transform: rotateZ(90deg)
    }
    .circle>span:nth-child(1) {
        top: 0
        left: 0
    }
    .circle>span:nth-child(2) {
        top: 0
        right: 0
    }
    .circle>span:nth-child(3) {
        right: 0
        bottom: 0
    }
    .circle>span:nth-child(4) {
        left: 0
        bottom: 0
    }
    .circle2>span:nth-child(1) {
        animation-delay: -1.1s
    }
    .circle3>span:nth-child(1) {
        animation-delay: -1s
    }
    .circle1>span:nth-child(2) {
        animation-delay: -0.9s
    }
    .circle2>span:nth-child(2) {
        animation-delay: -0.8s
    }
    .circle3>span:nth-child(2) {
        animation-delay: -0.7s
    }
    .circle1>span:nth-child(3) {
        animation-delay: -0.6s
    }
    .circle2>span:nth-child(3) {
        animation-delay: -0.7s
    }
    .circle3>span:nth-child(3) {
        animation-delay: -0.4s
    }
    .circle1>span:nth-child(4) {
        animation-delay: -0.3s
    }
    .circle2>span:nth-child(4) {
        animation-delay: -0.2s
    }
    .circle3>span:nth-child(4) {
        animation-delay: -0.1s
    }
    @keyframes mycircle {
        0% {
            transform: scale(0)
        }
        40% {
            transform: scale(1)
        }
        80% {
            transform: scale(0)
        }
        100% {
            transform: scale(0)
        }
    }
    @keyframes mycircle {
        0% {
            transform: scale(0)
        }
        40% {
            transform: scale(1)
        }
        80% {
            transform: scale(0)
        }
        100% {
            transform: scale(0)
        }
    }
}
/* loading4 */
.loading-shape4 {
    bottom: 0
    height: 60px
    left: 0
    margin: auto
    position: absolute
    right: 0
    top: -20%
    width: 100px
    .loader-line-wrap {
        animation: spin 2000ms cubic-bezier(0.175, 0.885, 0.32, 1.275) infinite
        box-sizing: border-box
        height: 50px
        left: 0
        overflow: hidden
        position: absolute
        top: 0
        transform-origin: 50% 100%
        width: 100px
    }
    .loader-line {
        border: 4px solid transparent
        border-radius: 100%
        box-sizing: border-box
        height: 100px
        left: 0
        margin: 0 auto
        position: absolute
        right: 0
        top: 0
        width: 100px
    }
    .loader-line-wrap:nth-child(1) {
        animation-delay: -50ms
    }
    .loader-line-wrap:nth-child(2) {
        animation-delay: -100ms
    }
    .loader-line-wrap:nth-child(3) {
        animation-delay: -150ms
    }
    .loader-line-wrap:nth-child(4) {
        animation-delay: -200ms
    }
    .loader-line-wrap:nth-child(5) {
        animation-delay: -250ms
    }
    .loader-line-wrap:nth-child(1) .loader-line {
        /* border-color: hsl(0, 80%, 60%); */
        border-color: #7bc0f9
        height: 80px
        width: 80px
        top: 7px
    }
    .loader-line-wrap:nth-child(2) .loader-line {
        /* border-color: hsl(60, 80%, 60%); */
        border-color: #4fabf7
        height: 66px
        width: 66px
        top: 14px
    }
    .loader-line-wrap:nth-child(3) .loader-line {
        /* border-color: hsl(120, 80%, 60%); */
        border-color: #2396f5
        height: 52px
        width: 52px
        top: 21px
    }
    .loader-line-wrap:nth-child(4) .loader-line {
        /* border-color: hsl(180, 80%, 60%); */
        border-color: #2087dd
        height: 38px
        width: 38px
        top: 28px
    }
    .loader-line-wrap:nth-child(5) .loader-line {
        /* border-color: hsl(240, 80%, 60%); */
        border-color: hsl(214, 83%, 54%)
        height: 24px
        width: 24px
        top: 35px
    }
    @keyframes spin {
        0%, 15% {
            transform: rotate(0)
        }
        100% {
            transform: rotate(360deg)
        }
    }
    @keyframes spin {
        0%, 15% {
            transform: rotate(0)
        }
        100% {
            transform: rotate(360deg)
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/base/no-content.vue